export enum RunModeEnum {
  /**
   * 即時模式
   */
  Live = 0,
  /**
   * 會議結束
   */
  Ended = 1,
}
